import type { FC } from 'react';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { NamedContainer } from '@alfa-bank/site-named-container';

import { GosuslugiIcon } from '../../../components/gosuslugi-icon';
import { ErrorIcon } from '../../../components/error-icon';
import { redirectUserToEsia, selectEsiaLoginStep } from '../../../store';
import type { TErrorAuthorizationToEsiaDesktop } from '../model';
import { defaultErrorAuthorizationToEsiaSettingsDesktop } from '../config/default-values';
import { sendEventSmev } from '../../../helpers/proxy-send-event';
import { analyticsErrorAuthorizationToEsiaStepSmev } from '../analytics';

export const ErrorAuthorizationToEsiaDesktop: FC<TErrorAuthorizationToEsiaDesktop> = ({
    Aligner,
    Text,
    buttonText = defaultErrorAuthorizationToEsiaSettingsDesktop.buttonText,
    description = defaultErrorAuthorizationToEsiaSettingsDesktop.description,
    title = defaultErrorAuthorizationToEsiaSettingsDesktop.title,
}) => {
    const dispatch = useDispatch();
    const { isLoading } = useSelector(selectEsiaLoginStep);

    const handleClick = () => {
        sendEventSmev(analyticsErrorAuthorizationToEsiaStepSmev.buttonClick);
        dispatch(redirectUserToEsia());
    };

    return (
        <Aligner>
            <ErrorIcon />
            {title && (
                <Text styler={{ marginBottom: 16, marginTop: 24 }} tag="h2" view="medium">
                    {title}
                </Text>
            )}
            {description && (
                <Text styler={{ marginTop: 0, marginBottom: 0 }} view="primary-medium">
                    {description}
                </Text>
            )}
            <Aligner styler={{ marginTop: 32 }}>
                <Button loading={isLoading} onClick={handleClick} size="s" view="secondary">
                    <NamedContainer name="leftAddons">
                        <GosuslugiIcon height={24} width={24} />
                    </NamedContainer>
                    {buttonText}
                </Button>
            </Aligner>
        </Aligner>
    );
};
